import TypeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';
import moment from 'moment';

import {
  GET_DEPRECIATION_REPORT_PAGINATED,
  SET_DEPRECIATION_REPORT_PAGINATION,
  SET_DEPRECIATION_REPORT_FILTERS,
  RESET_DEPRECIATION_REPORT,
  GET_DEPRECIATION_REPORT,
} from 'containers/reports/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const asset = new schema.Entity('assets');

export const initialState = {
  filters: {
    accounts: '',
    employees: '',
    costCenters: '',
    status: '',
    fulltext: '',
    depreciationType: 'fiscal',
    endDate: moment().toISOString(),
    columnSearch: ['number', 'name', 'indexInteger.indexString'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  needFetch: false,
  isLoading: false,
  entities: { assets: {} },
  result: { assets: [] },
};

export const getPending = (state) => ({
  ...state,
  isLoading: true,
  needFetch: false,
});
export const getRejected = (state) => ({ ...state, isLoading: false });

// TODO: Agregar page a paginacion
export const getFulfilled = (state, { payload }) => {
  const pagination = {
    ...state.pagination,
    limit: payload.limit,
    //page: payload.page
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  };

  const normalized = normalize({ assets: payload.records }, { assets: [asset] });

  return { ...state, isLoading: false, pagination, ...normalized };
};

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const getCSVPending = (state) => ({ ...state, isLoading: true });
export const getCSVRejected = (state) => ({ ...state, isLoading: false });
export const getCSVFulfilled = (state) => ({ ...state, isLoading: false });

const reportsReducers = {
  [GET_DEPRECIATION_REPORT_PAGINATED]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [GET_DEPRECIATION_REPORT]: {
    [PENDING]: getCSVPending,
    [FULFILLED]: getCSVRejected,
    [REJECTED]: getCSVFulfilled,
  },
  [SET_DEPRECIATION_REPORT_PAGINATION]: setPagination,
  [SET_DEPRECIATION_REPORT_FILTERS]: setFilters,
  [RESET_DEPRECIATION_REPORT]: reset,
};

export default TypeToReducer(reportsReducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/reducers/depreciation_report_reducers.js